import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import RoutingService from '../../services/routing.service';

@Component({
	standalone: true,
	selector: 'redirect-user',
	templateUrl: './redirect-user.component.html',
	imports: [ CommonModule, FormsModule ]
})
export default class RedirectUserView implements OnInit {
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.routingService.validateAccess('booking').then(() => {
			this.onResolve();
		});
	};
	
	onResolve() {
		this.vm.isLoading = false;
		this.processTargetLocation();
	}
	
	processTargetLocation() {
		// TODO ANGULAR_2 should this here be getQueryParam
		this.vm.targetUrl = this.angularRoutingHelperService.getRouteParam('targetUrl');
		if (!this.vm.targetUrl) {
			this.vm.targetUrl = this.angularRoutingHelperService.getQueryParam('targetUrl');
		}
		if (this.vm.targetUrl) {
			if (this.vm.targetUrl == 'idCardAuthSuccess=true') {
				this.angularRoutingHelperService.setQueryParam('targetUrl', null);
				this.angularRoutingHelperService.setPath('/');
			} else {
				window.location.href = this.vm.targetUrl;
			}
		} else {
			this.angularRoutingHelperService.setPath('/');
		}
	}
	
}